import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import ensureThreadContentItem from '@/redux/reducers/pieveReducer/ensureThreadContentItem.js';

const applyThreadAppConnectionSelectionSuccess = ({ state, payload }) => {
  const selection = payload?.data?.selection;
  const threadId = String(selection?.threadId || payload?.meta?.threadId || '').trim();
  const appId = String(selection?.appId || payload?.meta?.appId || '').trim();
  const ensuredThread = ensureThreadContentItem({ state, threadId });

  if (!selection || !threadId || !appId || !ensuredThread) {
    return state;
  }

  const currentSelections = Array.isArray(ensuredThread.threadContentItem?.appConnections) ? ensuredThread.threadContentItem.appConnections : [];

  return {
    ...state,
    threadContent: upsertThreadContentItem(ensuredThread.threadContent, {
      ...ensuredThread.threadContentItem,
      threadId,
      appConnections: [...currentSelections.filter((item) => item?.appId !== appId), selection]
    })
  };
};

export default applyThreadAppConnectionSelectionSuccess;
